// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineAlert_root__WlBFi","icon":"MantineAlert_icon__wJO4H","message":"MantineAlert_message__ZVrXo"};